export { GlobalHead } from './global-head';
